<template>
  <div>
    <div id="Chart8" style="width: 800px; height: 150px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts8() {
      var myChart8 = this.$echarts.init(document.getElementById("Chart8"));
      //配置图表
      var option8 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 20,
          top: 10,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["2017-01", "2018-01", "2019-01", "2020-01", "2021-01", "2022-01"],
          offset: 20,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            formatter: function (value) {
              if (value == "2017-01") {
                return `{a|${value}}`;
              } else {
                return `{b|${value}}`;
              }
            },
            rich: {
              a: {
                width: 100,
                align: "right",
              },
              b: {
                width: 100,
                align: "left",
              },
            },
          },
        },
        yAxis: {
          type: "value",
          min:"0",
          max:"100",
          interval:50,
          splitNumber:3,
          axisLabel: {
            formatter: function (value) {
              return `${value}%`
            },
          },
        },
        series: [
          {
            name: "股票",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#fcad2a",
            data: [70,30,59,40,57,70],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(252,173,42,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(252,173,42,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
          {
            name: "债券",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#539cff",
            data: [40,39,41,38,37,50],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(83,156,255,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(83,156,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
          {
            name: "现金",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#fd4c4c",
            data: [32,27,42,43,42,21,40],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(253,76,76,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(253,76,76,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
        ],
      };
      myChart8.setOption(option8);
    },
  },
  mounted() {
    this.myEcharts8();
  },
};
</script>

<style scoped>
#Chart1{
  margin-bottom: 12px;
}
</style>